const getAllNodesNames = (root) => {
  if (!root) return null

  const names = []
  Object.values(root).forEach((node) => {
    names.push(node?.name)
    if (node?.children) {
      names.push(...getAllNodesNames(node?.children))
    }
  })
  return [...new Set(names)]
}

export default getAllNodesNames
